import {
  referenceNumber,
  referenceString,
  type TaskReferenceResolver,
  type TaskReferenceRoute,
} from '@src/features/tasks';

/**
 * Where tasks about a user's own records open.
 *
 * Qualifications and schedules have no page of their own -- each is a tab on
 * the page of whoever holds it -- so both references carry the holder and the
 * tab to open on. That is why the payload names a user rather than the row the
 * task is about: the row is what the task is for, the user is where it lives.
 */
const userTab: TaskReferenceResolver = (data): TaskReferenceRoute | null => {
  const userId = referenceNumber(data.userId);
  if (userId === null) {
    return null;
  }

  return {
    to: '/users/$userId/edit',
    params: { userId: String(userId) },
    search: { tab: referenceString(data.tab), mode: referenceString(data.mode) },
  };
};

export const qualificationTaskReference = userTab;
export const scheduleTaskReference = userTab;
